// adminUsers.js — client wrappers for /api/admin-users.
//
// Auth credential changes (create user, change email, change password)
// require the Supabase service-role key, so they have to go through a
// server endpoint. The endpoint re-checks is_admin on the caller, so
// these calls will fail cleanly for non-admin sessions.

import { supabase } from './supabase';

async function bearer() {
  if (!supabase) throw new Error('Supabase not initialized');
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  if (!token) throw new Error('Not authenticated');
  return token;
}

async function call(body) {
  const token = await bearer();
  const res = await fetch('/api/admin-users', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization:  `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || `Request failed (${res.status})`);
  return data;
}

/** Create a new auth user with the given email + password. */
export function adminCreateUser({ email, password, fullName }) {
  return call({ action: 'create', email, password, full_name: fullName || null });
}

/** Update an existing user's email and/or password. */
export function adminUpdateUserAuth({ userId, email, password }) {
  return call({ action: 'update_auth', user_id: userId, email, password });
}

/** Hard-delete a user. Works for ALL auth methods — Google / Apple /
 *  email — since this hits auth.users via the service-role admin client.
 *  Cascading FKs on public.* clean up the rest. */
export function adminDeleteUser({ userId }) {
  return call({ action: 'delete', user_id: userId });
}
